import { render } from "./PhotoTab.vue?vue&type=template&id=7e416500&ts=true"
import script from "./PhotoTab.vue?vue&type=script&lang=ts"
export * from "./PhotoTab.vue?vue&type=script&lang=ts"

import "./PhotoTab.vue?vue&type=style&index=0&id=7e416500&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__